module.exports = __webpack_public_path__ + "img/product-1-thumb-2.e792edd8.jpg";